import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { headers, INSERT_UPDATE_DELEGATE_ITINERARY_ACTION_TYPE, GET_DELEGATE_ITINERARY_LIST_ACTION_TYPE, GET_DELEGATE_ITINERARY_DETAILS_ACTION_TYPE, insertDelegateItineraryUrl, getDelegateItineraryListUrl, getDelegateItineraryDetailsUrl, VERIFY_DELEGATE_ITINERARY_TIMESLOT_ACTION_TYPE, Verify_DelegateItineraryDateTimeSlotUrl, getDelegateB2BCheckScheduleUrl, GET_DELEGATE_B2B_CHECKED_SCHEDULE_ACTION_TYPE, delegateItineraryPathAUUrl } from "../../../utils/constants";


export const insertUpdateInvitationType_action = (ExhibitionID, DelegateRegistrationID, DelegateItineraryList) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            DelegateRegistrationID: DelegateRegistrationID,
            DelegateItineraryList: DelegateItineraryList,
        }

        const res = await axiosPost(insertDelegateItineraryUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_DELEGATE_ITINERARY_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const delegateItineraryPathAU_action = (DelegateRegistrationID, ItineraryFileType, DelegateRegistrationNo, ItineraryFile) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            DelegateRegistrationID: DelegateRegistrationID,
            ItineraryFileType: ItineraryFileType,
            DelegateRegistrationNo: DelegateRegistrationNo,
            ItineraryFile: ItineraryFile,
        }

        const res = await axiosPost(delegateItineraryPathAUUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_DELEGATE_ITINERARY_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getItineraryList_action = (ExhibitionID, CompanyName, Status) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            CompanyName: CompanyName,
            Status: Status,
        }

        const res = await axiosGet(getDelegateItineraryListUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_ITINERARY_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getItineraryDetails_action = (ExhibitionID, DelegateRegistrationID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            DelegateRegistrationID: DelegateRegistrationID
        }
        const res = await axiosGet(getDelegateItineraryDetailsUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_ITINERARY_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const Verify_DelegateItineraryDateTimeSlot_action = (ExhibitionID, DelegateRegistrationID, Date, StartTime, EndTime) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            DelegateRegistrationID: DelegateRegistrationID,
            Date: Date,
            StartTime: StartTime,
            EndTime: EndTime,
        }

        const res = await axiosGet(Verify_DelegateItineraryDateTimeSlotUrl, params, headers)

        dispatch({
            type: VERIFY_DELEGATE_ITINERARY_TIMESLOT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegateB2BCheckSchedule_action = (ExhibitionID, DelegateRegistrationID, ScheduleTypeID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            DelegateRegistrationID: DelegateRegistrationID,
            ScheduleTypeID: ScheduleTypeID,
        }

        const res = await axiosGet(getDelegateB2BCheckScheduleUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_B2B_CHECKED_SCHEDULE_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

